import LayoutSearch from "../components/LayoutSearch";
import css from "../css/sitemap/sitemap.module.css";

import Logo from "../components/header/Logo";
import States from "../components/sitemap/States";

import React from "react";
import { getStates } from "../service/cache";

const Sitemap = () => {
    const states = getStates();

    return (
        <LayoutSearch>
            <div className={css.block}>
                <div className={css.title}>
                    <Logo size="lg" />
                    <h1 className={css.titleSelected}>Real Estate Site Map</h1>
                </div>

                {states && <States states={states} />}
            </div>
        </LayoutSearch>
    );
};

export default Sitemap;
